/**
 * Redux store root — keep slice imports lean; do not register thunks that pull in megabyte-scale
 * API/client modules. See docs/architecture/frontend-bundling.md.
 */
import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import authReducer from '@/store/slices/auth.slice'
import navigationReducer from '@/store/slices/navigation.slice'
import permissionsReducer from '@/store/slices/permissions.slice'
import userReducer from '@/store/slices/user.slice'
import notificationReducer from '@/store/slices/notification.slice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    navigation: navigationReducer,
    permissions: permissionsReducer,
    user: userReducer,
    notification: notificationReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()

